<script>
    import ListItem from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/ListItem.svelte?1733898724643';
    import Error from '/srv/web/wyvr/html/releases/58819/gen/client/shop/Error.svelte?1733898724643';
    import CustomBlock from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/CustomBlock.svelte?1733898724643';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724643';

    export let name;
    export let products;
    export let store = 'en';
    export let locale = 'en';
    export let currency = 'EUR';
    export let id = undefined;

    $: is_filled = Array.isArray(products) && products.length > 0;
</script>

{#if is_filled}
    <section {id} data-list-name={name}>
        {#each products as product, index (get_attribute_value(product, 'sku'))}
            {@const position = index + 1}
            <div class="listitem">
                <ListItem {product} {store} {locale} {currency} {position} />
            </div>
            {#if position == 7}
                <CustomBlock {position} {product} {name} {store} />
            {/if}
        {/each}
        {#if products.length < 7}
            <CustomBlock position={products.length} {name} {store} />
        {/if}
    </section>
{:else}
    <Error text={window.__('category.no_products')} />
{/if}
<style>section {
    --columns: 1;
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    grid-gap: 1rem;
}

section > div {
    display: flex;
    align-items: stretch;
}

@media (min-width: 480px) {
    section {
        --columns: 2;
    }
}

@media (min-width: 992px) {
    section {
        --columns: 3;
    }
}

@media (min-width: 1240px) {
    section {
        --columns: 4;
    }
}
</style>